export default __webpack_public_path__ + "static/media/Lyrical__Aayat___Full_Song_with_Lyrics___Bajirao_Mastani.5e7f3e9b.mp3";